import React, { useState } from "react";

const treningiOpcje = [
  "Solo EMS",
  "Para EMS",
  "Para Personalny",
  "Solo Personalny",
  "Hybryda",
];

const generateTimeOptions = () => {
  const options = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      const time = `${String(hour).padStart(2, "0")}:${String(minute).padStart(
        2,
        "0"
      )}`;
      options.push(time);
    }
  }
  return options;
};

const timeOptions = generateTimeOptions();

const CreateTrenerzyModal = ({ isOpen, onClose, onCreate }) => {
  const [imie, setImie] = useState("");
  const [nazwisko, setNazwisko] = useState("");
  const [email, setEmail] = useState("");
  const [telefon, setTelefon] = useState("");
  const [typyTreningow, setTypyTreningow] = useState([]);
  const token = localStorage.getItem("token"); // Pobierz token z localStorage

  const [godzinyPracy, setGodzinyPracy] = useState([
    { dzien: "Poniedziałek", godzina_start: "", godzina_koniec: "" },
    { dzien: "Wtorek", godzina_start: "", godzina_koniec: "" },
    { dzien: "Środa", godzina_start: "", godzina_koniec: "" },
    { dzien: "Czwartek", godzina_start: "", godzina_koniec: "" },
    { dzien: "Piątek", godzina_start: "", godzina_koniec: "" },
    { dzien: "Sobota", godzina_start: "", godzina_koniec: "" },
    { dzien: "Niedziela", godzina_start: "", godzina_koniec: "" },
  ]);
  const [error, setError] = useState("");

  const handleCheckboxChange = (trening) => {
    if (typyTreningow.includes(trening)) {
      setTypyTreningow(typyTreningow.filter((t) => t !== trening));
    } else {
      setTypyTreningow([...typyTreningow, trening]);
    }
  };

  const handleCreate = () => {
    if (!imie || !nazwisko || !email || !telefon) {
      setError("Wszystkie pola są wymagane.");
      return;
    }

    if (typyTreningow.length === 0) {
      setError("Wybierz przynajmniej jeden typ treningu.");
      return;
    }

    for (const godzina of godzinyPracy) {
      if (!godzina.godzina_start || !godzina.godzina_koniec) {
        setError("Wszystkie godziny pracy muszą być wypełnione.");
        return;
      }
    }

    const newTrenerzy = {
      imie,
      nazwisko,
      email,
      telefon,
      godziny_pracy: godzinyPracy,
      typy_treningow: typyTreningow,
    };

    onCreate(newTrenerzy);
    resetForm();
  };

  const resetForm = () => {
    setImie("");
    setNazwisko("");
    setEmail("");
    setTelefon("");
    setTypyTreningow([]);
    setGodzinyPracy([
      { dzien: "Poniedziałek", godzina_start: "", godzina_koniec: "" },
      { dzien: "Wtorek", godzina_start: "", godzina_koniec: "" },
      { dzien: "Środa", godzina_start: "", godzina_koniec: "" },
      { dzien: "Czwartek", godzina_start: "", godzina_koniec: "" },
      { dzien: "Piątek", godzina_start: "", godzina_koniec: "" },
      { dzien: "Sobota", godzina_start: "", godzina_koniec: "" },
      { dzien: "Niedziela", godzina_start: "", godzina_koniec: "" },
    ]);
    setError("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <div className="bg-white rounded-lg shadow-lg p-8 z-10 w-[480px] max-h-[80vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-6">Dodaj Trenera</h2>
        {error && <p className="text-red-500">{error}</p>}

        <input
          type="text"
          placeholder="Imię"
          value={imie}
          onChange={(e) => setImie(e.target.value)}
          className="border border-gray-300 rounded-md p-2 w-full mb-4"
        />
        <input
          type="text"
          placeholder="Nazwisko"
          value={nazwisko}
          onChange={(e) => setNazwisko(e.target.value)}
          className="border border-gray-300 rounded-md p-2 w-full mb-4"
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border border-gray-300 rounded-md p-2 w-full mb-4"
        />
        <input
          type="tel"
          placeholder="Telefon"
          value={telefon}
          onChange={(e) => setTelefon(e.target.value)}
          className="border border-gray-300 rounded-md p-2 w-full mb-4"
        />

        <h3 className="text-lg font-semibold mb-2">Typy Treningów</h3>
        <div className="mb-4">
          {treningiOpcje.map((trening) => (
            <label key={trening} className="block">
              <input
                type="checkbox"
                checked={typyTreningow.includes(trening)}
                onChange={() => handleCheckboxChange(trening)}
                className="mr-2"
              />
              {trening}
            </label>
          ))}
        </div>

        <h3 className="text-lg font-semibold mb-2">Godziny Pracy</h3>
        {godzinyPracy.map((godzina, index) => (
          <div key={index} className="mb-4">
            <label className="block mb-1">{godzina.dzien}</label>
            <select
              value={godzina.godzina_start}
              onChange={(e) => {
                const newGodziny = [...godzinyPracy];
                newGodziny[index].godzina_start = e.target.value;
                setGodzinyPracy(newGodziny);
              }}
              className="border border-gray-300 rounded-md p-2 w-full mb-2"
            >
              <option value="">Wybierz godzinę startową</option>
              {timeOptions.map((time) => (
                <option key={time} value={time}>
                  {time}
                </option>
              ))}
            </select>
            <select
              value={godzina.godzina_koniec}
              onChange={(e) => {
                const newGodziny = [...godzinyPracy];
                newGodziny[index].godzina_koniec = e.target.value;
                setGodzinyPracy(newGodziny);
              }}
              className="border border-gray-300 rounded-md p-2 w-full mb-2"
            >
              <option value="">Wybierz godzinę koń cową</option>
              {timeOptions.map((time) => (
                <option key={time} value={time}>
                  {time}
                </option>
              ))}
            </select>
          </div>
        ))}

        <div className="flex justify-end gap-3">
          <button
            onClick={handleCreate}
            className="px-4 py-2 rounded-md text-white bg-blue-500 hover:bg-blue-600 transition-colors duration-200"
          >
            Dodaj Trenera
          </button>
          <button
            onClick={resetForm}
            className="px-4 py-2 rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
          >
            Anuluj
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateTrenerzyModal;
